import * as jwt_decode from 'jwt-decode';

export const getDecodedAccessToken = (token: string): any => {
  try {
    return jwt_decode.jwtDecode(token);
  } catch (Error) {
    return null;
  }
};
